import { module } from 'angular';

import { default as listDirectiveName, ListDirective } from './list.directive.ajs';

export default module('contact.commons.toolbox.list', []).directive(listDirectiveName, ListDirective).name;
